export default function partnerSuperEmployee({ next, store }) {
  const status = store.getters['auth/getRole']
  if (status === 'Partner' || status === 'Super-admin' || status === 'Employee') {
    return next()
  }
  return next({ name: 'misc-not-authorized' })
}
